import { useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom"; // 追加

import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import { ManagerWrapper, PrivateWrapper } from "contexts/privateRoute";

import Signin from "components/pages/signin";
import Home from "components/pages/home";

import Attendances from "components/pages/attendances";
import NotFound from "components/pages/notFound";

import ClassroomsManagement from "components/pages/management/classrooms";
import GradeSectionsManagement from "components/pages/management/gradeSections";
import StudentsManagement from "components/pages/management/students";
import StudentsDetailManagement from "components/pages/management/students/detail";

import ReportAttendances from "components/pages/report/attendances";

import { Navbar } from "components/ui/navbar";
import Sidebar from "components/ui/sidebar";

import { AuthProvider } from "contexts/authContext";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // color: mianColor,
        },
      },
    },
  },
}));

const AppLayout = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <RootStyle>
        <MainStyle>
          <Navbar onOpenSidebar={() => setOpen(true)} />
          <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
          <PrivateWrapper />
        </MainStyle>
      </RootStyle>
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CssBaseline />
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/signin" element={<Signin />} />
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="attendances" element={<Attendances />} />
            <Route path="management" element={<ManagerWrapper />}>
              <Route path="classrooms" element={<ClassroomsManagement />} />
              <Route
                path="grade_sections"
                element={<GradeSectionsManagement />}
              />
              <Route path="students">
                <Route index element={<StudentsManagement />} />
                <Route path="detail" element={<StudentsDetailManagement />} />
              </Route>
            </Route>

            <Route path="report" element={<ManagerWrapper />}>
              <Route path="attendances" element={<ReportAttendances />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
